<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>管理</el-breadcrumb-item>
      <!-- :to="{ path: '/' }" -->
      <el-breadcrumb-item>队伍订单管理</el-breadcrumb-item>

    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <div style="float: right;margin-right:2%;display: flex;align-items: center;">

      <!-- <el-button v-if="table2" style='margin: 10px;' size="mini" type="warning"
        icon="document" @click="dataSelect()">返回上一级</el-button>  -->
      <!-- v-if="table2" -->
      <div style="border: 1px solid #333;border-radius: 4px;">
        <el-date-picker style='margin: 10px 0;' v-model="dateTime" type="daterange" range-separator="-"
          start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
        </el-date-picker>
        <!-- v-if="table1"  -->
        <input placeholder="输入网点名称的关键字进行搜索" v-model="outlet" style='margin: 10px 0;width: 200px;margin: 8px;'></input>
        <el-button style='margin: 10px;' size="mini" type="primary" icon="document" @click="dataSelect()">搜索</el-button>
      </div>

      <span>
        <!-- v-if="table2" -->
        <input placeholder="输入订单号的关键字进行搜索" v-model="orderNo" style='margin: 10px 0;width: 200px;margin: 8px;'></input>
        <el-button style='margin: 10px;' size="mini" type="primary" icon="document"
          @click="dataSelect2('', { 'id': '' })">搜索</el-button>
      </span>
    </div>
    <el-table style="width:100%" border v-loading="tableDataLoading" :data="tableData" row-key="id"
      @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55">
      </el-table-column>
      <el-table-column v-if="table1" align="center" prop="outlet" label="网点名称">
      </el-table-column>
      <el-table-column v-if="table1" align="center" prop="business" label="队伍业务名称">
      </el-table-column>
      <el-table-column v-if="table2" align="center" prop="outlet" label="网点名称">
      </el-table-column>
      <el-table-column v-if="table2" align="center" prop="business" label="队伍业务名称">
      </el-table-column>
      <el-table-column v-if="table2" align="center" prop="orderNo" label="订单号">
      </el-table-column>
      <el-table-column v-if="table2" align="center" prop="nickName" label="取号用户名">
      </el-table-column>
      <el-table-column v-if="table2" align="center" prop="img" label="取号用户头像">
        <template slot-scope="scope">
          <el-image style="width: 100px; height: 100px" :src="scope.row.img" :preview-src-list="[scope.row.img]">
          </el-image>
        </template>
      </el-table-column>
      <el-table-column v-if="table2" align="center" prop="orderStatus" label="订单状态">
        <template slot-scope="scope">
          <span v-if="scope.row.orderStatus == 0">待支付</span>

          <span v-if="scope.row.orderStatus == 1 && scope.row.isAudit == 1">排队中</span>
          <span v-if="scope.row.orderStatus == 2 && scope.row.isAudit == 1">叫号中</span>
          <span v-if="scope.row.orderStatus == 3 && scope.row.isAudit == 1">已过号</span>
          <span v-if="scope.row.orderStatus == 4 && scope.row.isAudit == 1">已核销</span>
          <span v-if="scope.row.orderStatus == 5 && scope.row.isAudit == 1">已取消</span>

          <span v-if="scope.row.isAudit == 0 && scope.row.orderStatus !== 0">待审核</span>
          <!-- <span v-if="scope.row.orderStatus==1">审核通过</span> -->
          <span v-if="scope.row.isAudit == 2">审核不通过</span>
        </template>
      </el-table-column>
      <!-- 状态0待支付 1排队中 2叫号中 3已过号 4已核销 5巳取 -->
      <el-table-column v-if="table2" align="center" prop="nums" label="取号码">
      </el-table-column>
      <el-table-column v-if="table2" align="center" prop="phone" label="联系电话">
      </el-table-column>
      <el-table-column v-if="table2" align="center" prop="outlet" label="队伍名称">
        
      </el-table-column>
      <el-table-column v-if="table2" align="center" prop="orderMoney" label="取号金额">
      </el-table-column>
      <el-table-column v-if="table2" align="center" prop="payMoney" label="支付金额">
      </el-table-column>
      <el-table-column v-if="table2" align="center" prop="payTime" label="付款时间">
      </el-table-column>
      <el-table-column v-if="table2" align="center" prop="teamOrderFormList" label="其他信息">
        <template slot-scope="scope">
          <span v-if="scope.row.teamOrderFormList">
            <el-button size="mini" type="primary" @click="orderInfo(scope.row)">查看
            </el-button>
          </span>
          <span v-if="!scope.row.teamOrderFormList">无</span>
        </template>
      </el-table-column>

      <el-table-column align="center" label="操作" width="100px">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" v-if="table1" @click="dataSelect2(scope.$index, scope.row)">查询
          </el-button>
          <el-button size="mini" type="danger" v-if="table2" @click="tuikuang(scope.row.id)">退款
          </el-button>

          <!-- <el-button size="mini" type="primary" v-if="table1"
                @click="cs(scope.row.id)">测试
              </el-button> -->
        </template>
      </el-table-column>

    </el-table>
    <div v-if="table2" style="text-align: center;margin-top: 10px;">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 40]" :page-size="size" :current-page="page" layout="total,sizes, prev, pager, next"
        :total="totalnum">
      </el-pagination>
    </div>



    <el-dialog :title="titleOutlet" :visible.sync="dialogFormVisible" center>
      
      <!-- <div v-for="(item , index ) in infoFormList" style="margin-bottom: 10px;">
        <span style="width: 200px;display: inline-block;text-align: right;">{{item.name}}：{{ item.valuess }}</span>
        <el-input style="width:50%;" type="number" v-model="item.gold" placeholder="输入金币个数(整数数字)"></el-input>
      </div> -->
      <div v-for="(item , index ) in infoFormList">
        <el-row v-if="index%2==0" style="color: #409EFF;">
          <el-col :span="12"><div style=" margin: 10px;float: right;margin-right:2%;display: flex;align-items: center;" >{{item.name}}：</div></el-col>
          <el-col :span="12" style="border: 1px solid #333;border-radius: 4px;"><div style="margin: 10px;float: left;margin-right:2%;display: flex;align-items: center;">{{ item.valuess }}</div></el-col>
      </el-row>
      <!-- background- -->
      <el-row v-if="index%2==1" style="color: #67C23A;">
          <el-col :span="12"><div style=" margin: 10px;float: right;margin-right:2%;display: flex;align-items: center;" >{{item.name}}：</div></el-col>
          <el-col :span="12" style="border: 1px solid #333;border-radius: 4px;"><div style="margin: 10px;float: left;margin-right:2%;display: flex;align-items: center;">{{ item.valuess }}</div></el-col>
      </el-row>
      </div>
      
      

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">关 闭</el-button>
        <!-- <el-button type="primary" @click="releasNoticeTo()">添 加</el-button> -->
      </div>
    </el-dialog>

  </div>
</template>

<script>

import { getTeamList, getTeamOrderList, refundOrder, getAdminTeamFormList } from '../../../api/manage/teamOrder.js'

import moment from 'moment';

export default {
  data() {
    return {
      cashTotal: '',
      feeTotal: '',
      startDate: '',
      endDate: '',
      dateTime: '',
      outlet: '',
      titleOutlet:'',
      multipleSelection: [],
      totalnum: 0,
      page: 1,
      size: 10,
      tableDataLoading: false,
      dialogFormVisible: false,
      tableData: [],
      orderNo: '',
      table1: true,
      table2: false,
      teamId: '',
      infoList:[],
      infoFormList:[],
      updateForm: {

      },

    }
  },
  components: {

  },

  created() {
    this.dataSelect()
    // this.getdata(1)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

    cs(id,infoList) {
      let post = {
        teamId: id
      }
      this.tableDataLoading = true
      getAdminTeamFormList(post).then((res) => {
        this.tableDataLoading = false
        if (res.code == 200) {
          // this.infoFormList=res.data.list
          infoList.forEach(info => {
            res.data.list.forEach(list => {
              if(info.formId==list.id){
                info.name = list.name
              }
            });
          });
          this.infoFormList = infoList;
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      })

    },

    handleSizeChange(val) {
      this.size = val;
      this.dataSelect()
    },
    handleCurrentChange(val) {
      this.page = val;
      this.dataSelect()
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

     // 添加分类弹框
     orderInfo(row) {
      // this.infoList=;
        this.cs(row.teamId,row.teamOrderFormList);
        this.titleOutlet ='网点--'+row.outlet+'的其他信息'
        this.dialogFormVisible = true
    },

    tuikuang(id) {
      let obj = {
        id: id,
      }
      this.$confirm(`确定给此订单退款?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        refundOrder(obj).then(res => {
          this.$message({
            type: "success",
            message: res.msg,
            duration: 1500,
            onClose: () => {
              this.dataSelect()
            }
          });
        })
      }).catch(() => { })
    },

    dataSelect() {
      // let value=this.dateTime;
      // if (Array.isArray(value) && value.length === 2) {
      //   this.startDate = value[0];
      //   this.endDate = value[1];
      // } else {
      //   this.startDate = '';
      //   this.endDate = '';
      // }
      let post = {
        // page : (this.page - 1 ) * this.size,
        // size : this.size,
        outlet: this.outlet,
        // startDate : this.startDate,
        // endDate : this.endDate
      }
      this.tableDataLoading = true
      getTeamList(post).then((res) => {
        this.tableDataLoading = false
        if (res.code == 200) {
          this.table2 = false
          this.table1 = true
          this.tableData = res.data.list;
          // this.cashTotal = res.data.cashTotal,
          // this.feeTotal=res.data.feeTotal,
          // this.totalnum = res.data.count;
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      })

    },

    dataSelect2(index, row) {
      let value = this.dateTime;
      if (Array.isArray(value) && value.length === 2) {
        this.startDate = value[0];
        this.endDate = value[1];
      } else {
        this.startDate = '';
        this.endDate = '';
      }
      let post = {
        page: (this.page - 1) * this.size,
        size: this.size,
        orderNo: this.orderNo,
        teamId: row.id,
        startDate: this.startDate,
        endDate: this.endDate
      }
      this.tableDataLoading = true
      getTeamOrderList(post).then((res) => {
        this.tableDataLoading = false
        if (res.code == 200) {
          this.table2 = true
          this.table1 = false
          this.tableData = res.data.list
          this.cashTotal = res.data.cashTotal,
            this.feeTotal = res.data.feeTotal,
            this.totalnum = res.data.count;
          return;
        }
        this.$message({
          type: "info",
          message: res.msg,
        });
      })

    },

  }
}
</script>

<style scoped>
.userRole {
  width: 100%;

}
</style>


// WEBPACK FOOTER //
// src/views/manage/teamOrder/index.vue